import { FormConfig } from "src/app/shared/models/dynamic.model";

export interface MawbsModal {
    originAirport: string;
    destinationAirport: string;
    receivingAgent: string;
    clearanceType: string;
    mawb: string;
    flightNumber: string;
  }
  
  // Default MawbsModal values
  export const defaultMawbsModal: MawbsModal = {
    originAirport: '',
    destinationAirport: '',
    receivingAgent: '',
    clearanceType: '',
    mawb: '',
    flightNumber: '',
  };
  
  // State model interface
  export interface MawbModalStateModel {
    mawbModal: MawbsModal;
  }
  
  // Initial state
  export const defaultMawbState: MawbModalStateModel = {
    mawbModal: defaultMawbsModal,
  };

  export const mawbAdvancedSearchFormFieldsConfig: FormConfig = {
    fields: [
      {
        id: 'originAirport',
        type: 'input',
        label: 'Origin Airport',
        maxValue: 126,
      },
      {
        id: 'destinationAirport',
        type: 'input',
        label: 'Destination Airport',
        maxValue: 126,
      },
      {
        id: 'receivingAgent',
        type: 'input',
        label: 'Agent',
        maxValue: 126,
      },
      {
        id: 'clearanceType',
        type: 'input',
        label: 'Clearance Type',
        maxValue: 126,
      },
      {
        id: 'mawb',
        type: 'input',
        label: 'MAWB',
        maxValue: 126,
      },
      {
        id: 'flightNumber',
        type: 'input',
        label: 'Flight Number',
        maxValue: 126,
      },
    ],
  };

  /** Host module names as `getAdvanceSearchScreenName()` returns them. */
  export const mawbTabHostNames = {
    shipments: 'hawb',
    bags: 'bag',
  } as const;

  /**
   * MAWB-tab field ids that only some hosts render (PAC-25494 AC1/AC2, D-ASA-008).
   * Every id listed here must appear in at least one `mawbFieldIdsByHost` entry.
   */
  export const hostScopedMawbFieldIds: string[] = ['mawb', 'flightNumber'];

  /**
   * Which host-scoped ids each Advanced Search module shows. The Manifests host is
   * absent on purpose — AC3 names no MAWB-tab change, so it keeps the four base fields.
   */
  export const mawbFieldIdsByHost: Record<string, string[]> = {
    [mawbTabHostNames.shipments]: ['mawb', 'flightNumber'],
    [mawbTabHostNames.bags]: ['flightNumber'],
  };

  /**
   * Host-scoped ids the Bags payload must strip at submit. They stay in `MawbsModal`
   * for the Shipments host, so `updateAdvanceState` can repopulate them on Bags from a
   * restored pinned search — a field the user cannot see must not filter their results.
   * Derived from the two lists above so it cannot drift out of step with them.
   */
  export const shipmentOnlyMawbFieldIds: string[] = hostScopedMawbFieldIds.filter(
    id => !mawbFieldIdsByHost[mawbTabHostNames.bags].includes(id)
  );
